const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopperLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-141"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-141",
    cx: 251.11,
    cy: 326.51,
    rx: 230.89,
    ry: 133.31,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Form--inject-141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Questionary--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.55,410.85,81.41,409a4,4,0,0,1-1.79-3.11V173.16a4,4,0,0,1,1.79-3.1l144.4-83.38a4,4,0,0,1,3.59,0l3.14,1.82a4,4,0,0,1,1.8,3.1V324.37a4,4,0,0,1-1.8,3.11L88.14,410.85A4,4,0,0,1,84.55,410.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.32,91.31c-.13-.92-.88-1.26-1.78-.74L88.14,173.94a3.62,3.62,0,0,0-1.27,1.33l-6.73-3.88a3.7,3.7,0,0,1,1.27-1.33l144.4-83.38a4,4,0,0,1,3.59,0l3.14,1.82A4,4,0,0,1,234.32,91.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.82,411a.21.21,0,0,1-.1,0l-.19.07-.07,0c-.11,0-.22.06-.33.09h0A4.06,4.06,0,0,1,85,411a2.87,2.87,0,0,1-.4-.18L81.41,409a4,4,0,0,1-1.79-3.11V173.16a3.72,3.72,0,0,1,.52-1.77l6.73,3.88a3.65,3.65,0,0,0-.53,1.77V409.82a1.52,1.52,0,0,0,.27.94,1,1,0,0,0,1,.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.45,163.82a1.41,1.41,0,0,0-.32-.66l-.12-.1a.71.71,0,0,0-.67-.1.77.77,0,0,0-.25.11,2.82,2.82,0,0,0-1,1.23,4.35,4.35,0,0,0-.42,1.8,1.79,1.79,0,0,0,.4,1.29.79.79,0,0,0,1,.08,2.12,2.12,0,0,0,.56-.49,4.27,4.27,0,0,0,.38-.59,4.49,4.49,0,0,0,.49-1.94A3,3,0,0,0,138.45,163.82Zm23.48-52.47a3.34,3.34,0,0,0-1.72-.46,6.78,6.78,0,0,0-3.24,1,14.65,14.65,0,0,0-6,7.17c-.19.42-.37.86-.53,1.29s-.33.87-.47,1.32-.3.9-.43,1.35c-.05.15-.09.31-.14.45l-.26.91a.65.65,0,0,1,0,.13c-.15.55-.29,1.12-.45,1.68-.08.31-.15.6-.23.9l-.23.89c-.32,1.19-.64,2.33-1,3.42l-.23.66c-.11.31-.22.62-.34.92s-.19.46-.28.67c-.15.37-.31.72-.48,1.06s-.21.43-.32.64c-2.53,4.86-5.62,6.76-7.41,9.26-1.57,2.18-2,3.92-4.12,7.37-.67,1.1-1.51,2.37-2.61,3.89-3.05,4.2-4.14,6.28-4.51,7.54a.42.42,0,0,0,0,.1c0,.1,0,.19-.07.28a.37.37,0,0,0,0,.09,2.4,2.4,0,0,0,0,.24,5,5,0,0,0-.05.74v9.34l3.36,1.94v-9.35a4.51,4.51,0,0,1,.21-1.44c.37-1.26,1.45-3.33,4.51-7.53,1.1-1.53,1.94-2.8,2.61-3.9,2.1-3.44,2.55-5.19,4.12-7.35,0,0,0,0,0,0,1.79-2.51,4.88-4.4,7.41-9.27A22.92,22.92,0,0,0,150,135c1.62-4,2.35-9.39,4.34-13.92a14.56,14.56,0,0,1,6-7.15c2.05-1.18,3.55-1.28,4.7-.74Zm14.73,11.94h0a3.6,3.6,0,0,0-.89-.36c-1.27-.3-3.16.44-5.06.22,2.67,3.45,6.38,1.23,8.42,1.72a3.15,3.15,0,0,1,.9.37h0Zm7.12,12.83a1.86,1.86,0,0,0-.28.21l-.14.14-.13.15a4.21,4.21,0,0,0-.88,2.53,1.86,1.86,0,0,0,.39,1.28,1.27,1.27,0,0,0,.12.1.69.69,0,0,0,.66.1.85.85,0,0,0,.26-.11c.1-.06.19-.14.29-.21a2.87,2.87,0,0,0,.39-.45,4.3,4.3,0,0,0,.75-2.36C185.21,136.29,184.57,135.66,183.78,136.12Zm2.2-8.45a11,11,0,0,0-3.47-1.23c-.52-.12-1-.25-1.39-.38a9.75,9.75,0,0,0,4.74,2.31,13.62,13.62,0,0,1,3.1,1Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.23,129.54l-.27-.16a13.62,13.62,0,0,0-3.1-1,9.71,9.71,0,0,1-4.74-2.31,6.76,6.76,0,0,0-1.09-.82,3.19,3.19,0,0,0-.9-.36c-2-.49-5.75,1.73-8.41-1.72l-.09-.11c-1.86-2.51-2.54-8.11-5.33-9.75l-.28-.16c-1.15-.54-2.65-.44-4.7.74-7.39,4.27-7.64,14.41-10.3,21.08s-6.44,8.76-8.49,11.63-2.19,5-6.74,11.26-4.72,7.8-4.72,9v9.34l60.52-35v-9.34A2.36,2.36,0,0,0,189.23,129.54Zm-52.14,37.93c-.79.46-1.42-.15-1.42-1.37a3.77,3.77,0,0,1,1.42-3c.79-.46,1.42.16,1.42,1.38A3.75,3.75,0,0,1,137.09,167.47Zm23.23-28.14a3,3,0,0,1-4.66-1.43,8.61,8.61,0,0,1-.73-3.76c0-4.59,2.41-9.7,5.39-11.42a4.27,4.27,0,0,1,1.3-.51c2.36-.47,4.09,1.79,4.09,5.7C165.71,132.5,163.3,137.61,160.32,139.33Zm23.46,1.18c-.79.46-1.43-.15-1.43-1.36a3.78,3.78,0,0,1,1.43-3c.79-.45,1.43.16,1.43,1.38A3.74,3.74,0,0,1,183.78,140.51Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.23,129.54l-.27-.16a13.62,13.62,0,0,0-3.1-1,9.71,9.71,0,0,1-4.74-2.31,6.76,6.76,0,0,0-1.09-.82,3.19,3.19,0,0,0-.9-.36c-2-.49-5.75,1.73-8.41-1.72l-.09-.11c-1.86-2.51-2.54-8.11-5.33-9.75l-.28-.16c-1.15-.54-2.65-.44-4.7.74-7.39,4.27-7.64,14.41-10.3,21.08s-6.44,8.76-8.49,11.63-2.19,5-6.74,11.26-4.72,7.8-4.72,9v9.34l60.52-35v-9.34A2.36,2.36,0,0,0,189.23,129.54Zm-52.14,37.93c-.79.46-1.42-.15-1.42-1.37a3.77,3.77,0,0,1,1.42-3c.79-.46,1.42.16,1.42,1.38A3.75,3.75,0,0,1,137.09,167.47Zm23.23-28.14a3,3,0,0,1-4.66-1.43,8.61,8.61,0,0,1-.73-3.76c0-4.59,2.41-9.7,5.39-11.42a4.27,4.27,0,0,1,1.3-.51c2.36-.47,4.09,1.79,4.09,5.7C165.71,132.5,163.3,137.61,160.32,139.33Zm23.46,1.18c-.79.46-1.43-.15-1.43-1.36a3.78,3.78,0,0,1,1.43-3c.79-.45,1.43.16,1.43,1.38A3.74,3.74,0,0,1,183.78,140.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.28,165.39a4.51,4.51,0,0,0-.21,1.44v9.35l-3.36-1.94V164.9a5,5,0,0,1,.05-.74,2.4,2.4,0,0,1,0-.24.37.37,0,0,1,0-.09c0-.09,0-.18.07-.28l0-.1h0Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.52,146.61c-1.57,2.16-2,3.91-4.12,7.35L134.05,152c2.1-3.45,2.55-5.19,4.12-7.37h0Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36,121c-2,4.53-2.72,9.87-4.34,13.92a22.92,22.92,0,0,1-1.08,2.37l-3.36-1.93c.11-.21.22-.43.32-.64s.33-.69.48-1.06c.09-.21.19-.44.28-.67s.23-.61.34-.92l.23-.66c.36-1.09.68-2.23,1-3.42l.23-.89c.08-.3.15-.59.23-.9.16-.56.3-1.13.45-1.68a.65.65,0,0,0,0-.13l.26-.91c.05-.14.09-.3.14-.45.13-.45.28-.9.43-1.35s.3-.88.47-1.32.34-.87.53-1.29Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.08,164.3a4.35,4.35,0,0,0-.42,1.8,1.79,1.79,0,0,0,.4,1.29,1.85,1.85,0,0,1-.39-1.29A4.51,4.51,0,0,1,136.08,164.3Zm2.44.15a3,3,0,0,0-.07-.63,3,3,0,0,1,.06.63,4.48,4.48,0,0,1-.48,1.94A4.49,4.49,0,0,0,138.52,164.45Zm44.34-23.92a.69.69,0,0,0,.66.1A.76.76,0,0,1,182.86,140.53Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.72,127.91c0,4.59-2.42,9.7-5.4,11.42a3.05,3.05,0,0,1-4.66-1.42,4.26,4.26,0,0,0,1.31-.52c3-1.73,5.39-6.83,5.39-11.42a8.47,8.47,0,0,0-.74-3.76C164,121.74,165.72,124,165.72,127.91Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.72,127.91c0,4.59-2.42,9.7-5.4,11.42a3.05,3.05,0,0,1-4.66-1.42,4.26,4.26,0,0,0,1.31-.52c3-1.73,5.39-6.83,5.39-11.42a8.47,8.47,0,0,0-.74-3.76C164,121.74,165.72,124,165.72,127.91Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,166.39a3.12,3.12,0,0,1-.37.59,2.12,2.12,0,0,1-.56.49.79.79,0,0,1-1-.08,1.79,1.79,0,0,1-.4-1.29,4.35,4.35,0,0,1,.42-1.8,2.82,2.82,0,0,1,1-1.23.77.77,0,0,1,.25-.11.74.74,0,0,1,.79.2,1.41,1.41,0,0,1,.32.66,3,3,0,0,1,.07.63A4.24,4.24,0,0,1,138,166.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.21,137.5a4.3,4.3,0,0,1-.75,2.36,2.87,2.87,0,0,1-.39.45c-.1.07-.19.15-.29.21a.85.85,0,0,1-.26.11.74.74,0,0,1-.78-.2,1.86,1.86,0,0,1-.39-1.28,4.21,4.21,0,0,1,.88-2.53l.13-.15.14-.14a1.86,1.86,0,0,1,.28-.21C184.57,135.66,185.21,136.29,185.21,137.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.51,195.71l125.66-72.55a2.39,2.39,0,0,1,2.15,0l1.21.7a2.41,2.41,0,0,1,1.08,1.87v191.7a2.38,2.38,0,0,1-1.08,1.86L100.87,391.84a2.33,2.33,0,0,1-2.15,0l-1.21-.7a2.37,2.37,0,0,1-1.08-1.86V197.58A2.38,2.38,0,0,1,97.51,195.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.57,125.4c-.14-.44-.55-.58-1-.3L100.87,197.65a2.2,2.2,0,0,0-.76.81l-3.36-1.94a2,2,0,0,1,.76-.8l125.66-72.55a2.31,2.31,0,0,1,2.14,0l1.22.69A2.4,2.4,0,0,1,227.57,125.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.62,392a1.8,1.8,0,0,1-.4.1l-.21,0a2.84,2.84,0,0,1-.65,0,1.67,1.67,0,0,1-.4-.1l-.24-.12-1.21-.7a2.35,2.35,0,0,1-1.08-1.86V197.58a2.11,2.11,0,0,1,.32-1.06l3.36,1.94a2.26,2.26,0,0,0-.31,1.06v191.7C99.8,391.81,100.14,392.1,100.62,392Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.26,151.68l-.17.28a7,7,0,0,0-.86,2.12c0,.06,0,.09,0,.12a.18.18,0,0,0,0,.05l-2.05,11.54-.64,3.69c0,.15-.07.3-.11.46a4.43,4.43,0,0,1-.14.44c0,.1-.07.2-.11.3l3.36,1.94a5.68,5.68,0,0,0,.35-1.2l.66-3.69,2-11.54a6.22,6.22,0,0,1,1.05-2.57Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.12,188.91c-.34.54-.66,1.08-1,1.62-.14.26-.28.52-.41.78s-.32.67-.46,1-.32.74-.46,1.12-.28.76-.41,1.14-.29.89-.41,1.34c-.08.29-.16.58-.24.89q-.28,1.06-.51,2.16c0,.25-.11.51-.15.76s-.13.62-.18.92c0,0,0,0,0,.05,0,.24,0,.4.12.47a.12.12,0,0,0,.1,0h0L126,198.9l.47-.37.23-.17.25-.2.2-.15.17-.14a25.47,25.47,0,0,1,4.15-8.47l-3.36-1.94C127.78,187.94,127.44,188.43,127.12,188.91Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.48,126.29c-.16.26-.3.52-.44.78a3.21,3.21,0,0,0-.24.45c-.12.21-.22.43-.33.65s-.18.35-.26.53c-.17.34-.32.68-.46,1s-.32.74-.46,1.11a0,0,0,0,0,0,0c-.14.33-.25.66-.36,1-.18.5-.33,1-.47,1.51-.08.27-.14.53-.21.79a.35.35,0,0,1,0,.06c0,.14-.07.27-.09.41-.08.31-.14.63-.19.94s-.1.49-.17.74-.13.52-.21.78-.16.49-.24.74c0,0,0,0,0,.07-.1.27-.21.55-.33.83s-.22.55-.36.84a2.18,2.18,0,0,0-.09.23c-.1.21-.21.42-.31.64l-.53,1c-.12.24-.24.46-.37.69l3.37,1.94a22.79,22.79,0,0,0,2.62-6.58,28.91,28.91,0,0,1,3.54-9.28Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.47,133.77a1.28,1.28,0,0,0-.55-.18,4.11,4.11,0,0,0,3,1.9,2.18,2.18,0,0,1,.84.18Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.47,133.77a1.28,1.28,0,0,0-.55-.18,4.11,4.11,0,0,0,3,1.9,2.18,2.18,0,0,1,.84.18Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,148.38a3.62,3.62,0,0,0-3.37.1c-3.91,1.72-5.6,2.5-7.62,3.34-.39,2.6,1.14,2.84,1.9,2.53,2.84-1.12,4.29-1.81,9.09-3.92a3.63,3.63,0,0,1,3.34-.11Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,148.38a3.62,3.62,0,0,0-3.37.1c-3.91,1.72-5.6,2.5-7.62,3.34-.39,2.6,1.14,2.84,1.9,2.53,2.84-1.12,4.29-1.81,9.09-3.92a3.63,3.63,0,0,1,3.34-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,172.62a13.75,13.75,0,0,1-3,4.22L136,184.75a28,28,0,0,0-4.52,4.65l-3.36-1.94a27.65,27.65,0,0,1,4.52-4.66l10.54-7.9a14,14,0,0,0,2.95-4.22Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,172.62a13.75,13.75,0,0,1-3,4.22L136,184.75a28,28,0,0,0-4.52,4.65l-3.36-1.94a27.65,27.65,0,0,1,4.52-4.66l10.54-7.9a14,14,0,0,0,2.95-4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.68,144.1a35.82,35.82,0,0,1-5.32,7.4,12.64,12.64,0,0,0-1.74,2.12l-3.36-1.94a11.47,11.47,0,0,1,1.74-2.12,35.83,35.83,0,0,0,5.31-7.4Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.68,144.1a35.82,35.82,0,0,1-5.32,7.4,12.64,12.64,0,0,0-1.74,2.12l-3.36-1.94a11.47,11.47,0,0,1,1.74-2.12,35.83,35.83,0,0,0,5.31-7.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.66,119.27c-1.24-.65-2.89-.54-4.83.48-2.88,1.51-5.78,4.71-8,8.49l-3.36-2c2.2-3.78,5.1-7,8-8.49a6.77,6.77,0,0,1,3.08-.87,3.69,3.69,0,0,1,1.85.47Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.66,119.27c-1.24-.65-2.89-.54-4.83.48-2.88,1.51-5.78,4.71-8,8.49l-3.36-2c2.2-3.78,5.1-7,8-8.49a6.77,6.77,0,0,1,3.08-.87,3.69,3.69,0,0,1,1.85.47Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.51,189.4a25.47,25.47,0,0,0-4.15,8.47l-.17.14-.2.15-.25.2-.23.17-.47.37-2.85,2.28h0a.12.12,0,0,1-.1,0c-.11-.07-.16-.23-.12-.47,0,0,0,0,0-.05,0-.3.11-.61.18-.92s.1-.51.15-.76q.23-1.09.51-2.16c.08-.31.16-.6.24-.89.12-.45.26-.89.41-1.34s.26-.76.41-1.14.29-.75.46-1.12.3-.69.46-1,.27-.52.41-.78c.29-.54.61-1.08,1-1.62s.66-1,1-1.45Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.62,153.62a6.22,6.22,0,0,0-1.05,2.57l-2,11.54-.66,3.69a5.68,5.68,0,0,1-.35,1.2l-3.36-1.94c0-.1.08-.2.11-.3a4.43,4.43,0,0,0,.14-.44c0-.16.08-.31.11-.46l.64-3.69,2.05-11.54a.18.18,0,0,1,0-.05s0-.06,0-.12a7,7,0,0,1,.86-2.12l.17-.28Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.84,128.24a28.91,28.91,0,0,0-3.54,9.28,22.79,22.79,0,0,1-2.62,6.58l-3.37-1.94c.13-.23.25-.45.37-.69l.53-1c.1-.22.21-.43.31-.64a2.18,2.18,0,0,1,.09-.23c.13-.28.25-.57.36-.84s.23-.56.33-.83c0,0,0-.05,0-.07.08-.25.17-.49.24-.74s.15-.52.21-.78.12-.5.17-.74.11-.63.19-.94c0-.14.06-.27.09-.41a.35.35,0,0,0,0-.06c.07-.26.13-.52.21-.79.14-.51.29-1,.47-1.51.11-.34.22-.67.36-1a0,0,0,0,1,0,0c.14-.37.3-.74.46-1.11s.29-.68.46-1c.08-.18.17-.35.26-.53s.21-.44.33-.65a3.21,3.21,0,0,1,.24-.45c.14-.26.28-.52.44-.78Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.16,201.18h0L126,198.9C124.87,199.81,123.33,201,123.16,201.18Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.35,150.34l0,0a3.67,3.67,0,0,0-3.35.1c-4.79,2.12-6.24,2.81-9.08,3.94-.76.3-2.29.06-1.9-2.54a1.22,1.22,0,0,1,0-.17l.65-3.69,1.82-10.06s.41-1.59-.64-2.18l-.08,0a1.76,1.76,0,0,0-.83-.18,4.12,4.12,0,0,1-3-1.92,7.56,7.56,0,0,1-1.13-5.75c.77-4.32-.07-7.34-2-8.46l-.15-.1c-1.24-.65-2.89-.54-4.83.48-5.11,2.68-10.27,10.63-11.53,17.77-.79,4.5-5.32,11.43-7.94,14s-2.79,4.69-2.79,4.69l-2,11.54-.66,3.69c-.48,2.76-3.31,5.43-3.31,5.43L136,184.75a25.39,25.39,0,0,0-8.67,13.12s-4,3.06-4.2,3.31h0l1.35-.77,72.72-41.81s.84-.45,1-.57,3.11-2.88,3.11-2.88C201.26,152.77,200.57,151.07,199.35,150.34Zm-21-21.21c-.78,4.39-3.94,9.28-7.08,10.93-2.17,1.13-3.76.43-4.29-1.57a8.37,8.37,0,0,1,0-3.4c.77-4.39,3.95-9.28,7.09-10.92a5.3,5.3,0,0,1,.91-.39C177.55,123,179,125.19,178.33,129.13Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.17,201.19l74.08-42.58,1-.57c.18-.11,3.11-2.89,3.11-2.89l-74,42.72S122.88,201.35,123.17,201.19Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.17,201.19l74.08-42.58,1-.57c.18-.11,3.11-2.89,3.11-2.89l-74,42.72S122.88,201.35,123.17,201.19Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,123.78a5.3,5.3,0,0,0-.91.39c-3.14,1.64-6.32,6.53-7.09,10.92a8.37,8.37,0,0,0,0,3.4c.53,2,2.12,2.7,4.29,1.57,3.14-1.65,6.3-6.54,7.08-10.93C179,125.19,177.55,123,175,123.78Zm-7.8,14.63a8.19,8.19,0,0,1,0-3.28c.77-4.34,3.9-9.17,7-10.78A5.93,5.93,0,0,1,175,124a8.41,8.41,0,0,1,0,3.2c-.77,4.39-3.94,9.28-7.09,10.93a5.29,5.29,0,0,1-.71.31Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,123.78a5.3,5.3,0,0,0-.91.39c-3.14,1.64-6.32,6.53-7.09,10.92a8.37,8.37,0,0,0,0,3.4c.53,2,2.12,2.7,4.29,1.57,3.14-1.65,6.3-6.54,7.08-10.93C179,125.19,177.55,123,175,123.78Zm-7.8,14.63a8.19,8.19,0,0,1,0-3.28c.77-4.34,3.9-9.17,7-10.78A5.93,5.93,0,0,1,175,124a8.41,8.41,0,0,1,0,3.2c-.77,4.39-3.94,9.28-7.09,10.93a5.29,5.29,0,0,1-.71.31Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67,257.69a.89.89,0,0,1-.45-.12,1.06,1.06,0,0,1-.48-1V252.3a2.37,2.37,0,0,1,1.1-1.91l3.73-2.15a1,1,0,0,1,1.55.89v4.31a2.35,2.35,0,0,1-1.1,1.91l-3.73,2.16A1.25,1.25,0,0,1,116.67,257.69Zm4.52-8.74a.78.78,0,0,0-.17.07l-3.73,2.15a1.48,1.48,0,0,0-.65,1.13v4.31a.33.33,0,0,0,0,.18.52.52,0,0,0,.17-.06l3.73-2.16a1.48,1.48,0,0,0,.65-1.13v-4.31A.57.57,0,0,0,121.19,249Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.29,247.62l14.7-8.49c.49-.28.88-.06.88.5v1.15a1.93,1.93,0,0,1-.88,1.51l-14.7,8.49c-.48.28-.88.06-.88-.5v-1.15A1.93,1.93,0,0,1,125.29,247.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,236.66a.87.87,0,0,1-.45-.12,1.06,1.06,0,0,1-.49-1v-4.31a2.38,2.38,0,0,1,1.11-1.91l3.73-2.15a1,1,0,0,1,1.07-.06,1,1,0,0,1,.48.95v4.31a2.35,2.35,0,0,1-1.1,1.91l-3.73,2.16A1.25,1.25,0,0,1,153.1,236.66Zm4.51-8.74a1.37,1.37,0,0,0-.16.07l-3.73,2.15a1.49,1.49,0,0,0-.66,1.13v4.31a.28.28,0,0,0,0,.18.62.62,0,0,0,.17-.06l3.73-2.16a1.46,1.46,0,0,0,.65-1.13V228.1A.31.31,0,0,0,157.61,227.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,226.59l14.7-8.49c.49-.28.88-.06.88.5v1.15a1.93,1.93,0,0,1-.88,1.51l-14.7,8.49c-.49.28-.88.06-.88-.5V228.1A2,2,0,0,1,161.72,226.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,215.63a.89.89,0,0,1-.45-.12,1.08,1.08,0,0,1-.48-1v-4.31a2.38,2.38,0,0,1,1.1-1.91h0l3.73-2.15a1,1,0,0,1,1.56.9v4.3a2.36,2.36,0,0,1-1.11,1.91l-3.73,2.16A1.23,1.23,0,0,1,189.52,215.63Zm.62-6.52a1.51,1.51,0,0,0-.65,1.13v4.31a.28.28,0,0,0,0,.18.35.35,0,0,0,.16-.06l3.73-2.16a1.49,1.49,0,0,0,.66-1.13v-4.3a.33.33,0,0,0,0-.19s-.06,0-.17.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.15,205.56l14.7-8.49c.48-.28.88-.06.88.5v1.15a2,2,0,0,1-.88,1.51l-14.7,8.49c-.49.28-.88.06-.88-.5v-1.15A1.93,1.93,0,0,1,198.15,205.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,226.58v1.68c0,.92.64,1.29,1.43.83l86-49.61a3.18,3.18,0,0,0,1.43-2.49V175.3c0-.91-.64-1.28-1.43-.83l-86,49.62A3.18,3.18,0,0,0,125.33,226.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.78,213.46v1.68c0,.92.64,1.29,1.44.83l85.95-49.61a3.16,3.16,0,0,0,1.44-2.49v-1.69c0-.91-.64-1.28-1.44-.83L120.22,211A3.16,3.16,0,0,0,118.78,213.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,236.75v1.69c0,.91.64,1.28,1.43.83l86-49.61a3.18,3.18,0,0,0,1.43-2.49v-1.69c0-.91-.64-1.28-1.43-.83l-86,49.62A3.18,3.18,0,0,0,125.33,236.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,237.62c2.25-2.23,2.81-3.18,2.81-4s-.33-1.26-1.34-.68a3.46,3.46,0,0,0-1.67,2.4l-2.46.55a9.2,9.2,0,0,1,4.21-6.3c2.46-1.42,3.89-.36,3.89,2a9.13,9.13,0,0,1-2.8,6.05v1.95l-2.64,1.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.88,244.1a2.76,2.76,0,0,1,1.34-2.39c.88-.51,1.33-.06,1.33.85a2.77,2.77,0,0,1-1.33,2.41C116.33,245.48,115.88,245,115.88,244.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25,252.3l1.1.83-1,1.9a.67.67,0,0,0,0,.8c.19.14.46,0,.62-.3l1-1.89,1.1.83c.16.12.4,0,.54-.26a.58.58,0,0,0,0-.69l-1.1-.83,1-1.9a.67.67,0,0,0,0-.8c-.19-.14-.46,0-.62.3l-1,1.9-1.1-.83c-.16-.12-.4,0-.54.25A.58.58,0,0,0,117.25,252.3Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67,295.66a.88.88,0,0,1-.45-.11,1.06,1.06,0,0,1-.48-1v-4.31a2.35,2.35,0,0,1,1.1-1.91l3.73-2.15a1,1,0,0,1,1.55.89v4.31a2.35,2.35,0,0,1-1.1,1.91l-3.73,2.15A1.25,1.25,0,0,1,116.67,295.66Zm4.52-8.73a.44.44,0,0,0-.17.07l-3.73,2.15a1.48,1.48,0,0,0-.65,1.13v4.31a.33.33,0,0,0,0,.18.52.52,0,0,0,.17-.06l3.73-2.16a1.48,1.48,0,0,0,.65-1.13v-4.31A.57.57,0,0,0,121.19,286.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.29,285.59l14.7-8.48c.49-.28.88-.06.88.5v1.14a1.93,1.93,0,0,1-.88,1.52l-14.7,8.49c-.48.28-.88.05-.88-.51v-1.14A1.94,1.94,0,0,1,125.29,285.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,274.63a.86.86,0,0,1-.45-.11,1.06,1.06,0,0,1-.49-1v-4.31a2.36,2.36,0,0,1,1.11-1.91l3.73-2.15a1,1,0,0,1,1.07-.06,1,1,0,0,1,.48.95v4.31a2.35,2.35,0,0,1-1.1,1.91l-3.73,2.15A1.25,1.25,0,0,1,153.1,274.63Zm4.51-8.73a.52.52,0,0,0-.16.07l-3.73,2.15a1.49,1.49,0,0,0-.66,1.13v4.31a.28.28,0,0,0,0,.18.62.62,0,0,0,.17-.06l3.73-2.16a1.48,1.48,0,0,0,.65-1.13v-4.31A.31.31,0,0,0,157.61,265.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,264.56l14.7-8.48c.49-.28.88-.06.88.5v1.14a1.93,1.93,0,0,1-.88,1.52l-14.7,8.49c-.49.28-.88,0-.88-.51v-1.14A2,2,0,0,1,161.72,264.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,253.6a.88.88,0,0,1-.45-.11,1.08,1.08,0,0,1-.48-1v-4.31a2.38,2.38,0,0,1,1.1-1.91h0l3.73-2.15a1,1,0,0,1,1.56.89v4.31a2.36,2.36,0,0,1-1.11,1.91l-3.73,2.15A1.23,1.23,0,0,1,189.52,253.6Zm.62-6.51a1.51,1.51,0,0,0-.65,1.13v4.31a.28.28,0,0,0,0,.18.64.64,0,0,0,.16-.06l3.73-2.16a1.49,1.49,0,0,0,.66-1.13v-4.31a.31.31,0,0,0,0-.18.62.62,0,0,0-.17.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.15,243.53l14.7-8.48c.48-.28.88-.06.88.5v1.14a2,2,0,0,1-.88,1.52l-14.7,8.49c-.49.28-.88.05-.88-.51v-1.14A1.93,1.93,0,0,1,198.15,243.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,264.55v1.69c0,.91.64,1.28,1.43.83l86-49.61a3.18,3.18,0,0,0,1.43-2.49v-1.69c0-.91-.64-1.28-1.43-.83l-86,49.62A3.18,3.18,0,0,0,125.33,264.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,274.73v1.69c0,.91.64,1.28,1.43.83l86-49.62a3.14,3.14,0,0,0,1.43-2.48v-1.69c0-.92-.64-1.29-1.43-.83l-86,49.62A3.18,3.18,0,0,0,125.33,274.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,275.6c2.25-2.23,2.81-3.18,2.81-4s-.33-1.26-1.34-.68a3.46,3.46,0,0,0-1.67,2.4l-2.46.55a9.2,9.2,0,0,1,4.21-6.3c2.46-1.42,3.89-.36,3.89,2.05a9.13,9.13,0,0,1-2.8,6.05v1.95l-2.64,1.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.88,282.08a2.76,2.76,0,0,1,1.34-2.39c.88-.51,1.33-.06,1.33.85a2.78,2.78,0,0,1-1.33,2.41C116.33,283.46,115.88,283,115.88,282.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.68,269.21l1.1.83-1,1.9a.67.67,0,0,0,0,.8c.18.14.46,0,.62-.3l1-1.89,1.1.83c.16.12.4,0,.53-.26a.58.58,0,0,0,0-.69l-1.1-.83,1-1.9a.66.66,0,0,0-.05-.8c-.18-.13-.46,0-.62.3l-1,1.9-1.1-.83c-.15-.12-.39,0-.53.25A.57.57,0,0,0,153.68,269.21Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67,333.64a.89.89,0,0,1-.45-.12,1,1,0,0,1-.48-.95v-4.31a2.35,2.35,0,0,1,1.1-1.91l3.73-2.15a1,1,0,0,1,1.55.89v4.31a2.35,2.35,0,0,1-1.1,1.91l-3.73,2.15A1.25,1.25,0,0,1,116.67,333.64Zm4.52-8.73a.44.44,0,0,0-.17.07l-3.73,2.15a1.48,1.48,0,0,0-.65,1.13v4.31a.36.36,0,0,0,0,.18.44.44,0,0,0,.17-.07l3.73-2.15a1.48,1.48,0,0,0,.65-1.13v-4.31A.57.57,0,0,0,121.19,324.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.29,323.57l14.7-8.49c.49-.28.88-.05.88.51v1.14a1.93,1.93,0,0,1-.88,1.52l-14.7,8.49c-.48.28-.88.05-.88-.51v-1.14A1.94,1.94,0,0,1,125.29,323.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,312.61a.87.87,0,0,1-.45-.12,1,1,0,0,1-.49-.95v-4.31a2.36,2.36,0,0,1,1.11-1.91l3.73-2.15a1.06,1.06,0,0,1,1.07-.07,1.08,1.08,0,0,1,.48,1v4.31a2.35,2.35,0,0,1-1.1,1.91l-3.73,2.15A1.25,1.25,0,0,1,153.1,312.61Zm4.51-8.73a.52.52,0,0,0-.16.07l-3.73,2.15a1.49,1.49,0,0,0-.66,1.13v4.31a.31.31,0,0,0,0,.18.51.51,0,0,0,.17-.07L157,309.5a1.48,1.48,0,0,0,.65-1.13v-4.31A.28.28,0,0,0,157.61,303.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,302.54l14.7-8.49c.49-.27.88-.05.88.51v1.14a1.93,1.93,0,0,1-.88,1.52l-14.7,8.49c-.49.28-.88.05-.88-.51v-1.14A2,2,0,0,1,161.72,302.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,291.58a.89.89,0,0,1-.45-.12,1,1,0,0,1-.48-.95V286.2a2.35,2.35,0,0,1,1.1-1.91h0l3.73-2.15A1,1,0,0,1,195,283v4.31a2.36,2.36,0,0,1-1.11,1.91l-3.73,2.15A1.23,1.23,0,0,1,189.52,291.58Zm.62-6.51a1.51,1.51,0,0,0-.65,1.13v4.31a.31.31,0,0,0,0,.18.52.52,0,0,0,.16-.07l3.73-2.15a1.49,1.49,0,0,0,.66-1.13V283a.31.31,0,0,0,0-.18.77.77,0,0,0-.17.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.15,281.51l14.7-8.49c.48-.27.88,0,.88.51v1.14a2,2,0,0,1-.88,1.52l-14.7,8.49c-.49.28-.88.05-.88-.51V283A1.93,1.93,0,0,1,198.15,281.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,302.53v1.69c0,.91.64,1.28,1.43.83l86-49.62a3.14,3.14,0,0,0,1.43-2.48v-1.69c0-.91-.64-1.29-1.43-.83l-86,49.62A3.18,3.18,0,0,0,125.33,302.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,312.71v1.69c0,.91.64,1.28,1.43.82l86-49.61a3.16,3.16,0,0,0,1.43-2.48v-1.69c0-.92-.64-1.29-1.43-.83l-86,49.62A3.16,3.16,0,0,0,125.33,312.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,313.58c2.25-2.23,2.81-3.18,2.81-4s-.33-1.27-1.34-.68a3.46,3.46,0,0,0-1.67,2.4l-2.46.54a9.2,9.2,0,0,1,4.21-6.29c2.46-1.42,3.89-.36,3.89,2a9.13,9.13,0,0,1-2.8,6.05v1.95l-2.64,1.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.88,320.06a2.77,2.77,0,0,1,1.34-2.4c.88-.5,1.33-.05,1.33.86a2.79,2.79,0,0,1-1.33,2.41C116.33,321.44,115.88,321,115.88,320.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.11,286.16l1.09.83-1,1.9a.66.66,0,0,0,0,.8c.18.14.46,0,.62-.3l1-1.9,1.1.83c.16.12.39,0,.53-.25a.57.57,0,0,0,0-.69l-1.1-.83,1-1.9a.69.69,0,0,0-.05-.8c-.18-.14-.46,0-.62.3l-1,1.9-1.1-.84c-.16-.12-.4,0-.53.26A.57.57,0,0,0,190.11,286.16Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67,371.62a.89.89,0,0,1-.45-.12,1,1,0,0,1-.48-.95v-4.31a2.35,2.35,0,0,1,1.1-1.91l3.73-2.16a1.09,1.09,0,0,1,1.07-.06,1.06,1.06,0,0,1,.48,1v4.31a2.38,2.38,0,0,1-1.1,1.91l-3.73,2.15A1.25,1.25,0,0,1,116.67,371.62Zm4.52-8.73a.52.52,0,0,0-.17.06l-3.73,2.16a1.48,1.48,0,0,0-.65,1.13v4.31a.36.36,0,0,0,0,.18.78.78,0,0,0,.17-.07l3.73-2.15a1.48,1.48,0,0,0,.65-1.13v-4.31A.5.5,0,0,0,121.19,362.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.29,361.55l14.7-8.49c.49-.28.88-.05.88.51v1.14a1.93,1.93,0,0,1-.88,1.52l-14.7,8.49c-.48.28-.88,0-.88-.51v-1.14A1.94,1.94,0,0,1,125.29,361.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,350.59a.87.87,0,0,1-.45-.12,1,1,0,0,1-.49-1v-4.31a2.36,2.36,0,0,1,1.11-1.91l3.73-2.16a1,1,0,0,1,1.55.9v4.31a2.35,2.35,0,0,1-1.1,1.91l-3.73,2.15A1.25,1.25,0,0,1,153.1,350.59Zm4.51-8.73a.64.64,0,0,0-.16.06l-3.73,2.16a1.49,1.49,0,0,0-.66,1.13v4.31a.31.31,0,0,0,0,.18,1.1,1.1,0,0,0,.17-.07l3.73-2.15a1.48,1.48,0,0,0,.65-1.13V342A.28.28,0,0,0,157.61,341.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,340.52l14.7-8.49c.49-.28.88,0,.88.51v1.14a1.93,1.93,0,0,1-.88,1.52l-14.7,8.49c-.49.28-.88.05-.88-.51V342A2,2,0,0,1,161.72,340.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,329.56a.89.89,0,0,1-.45-.12,1,1,0,0,1-.48-.95v-4.31a2.35,2.35,0,0,1,1.1-1.91h0l3.73-2.16a1.11,1.11,0,0,1,1.08-.06,1.08,1.08,0,0,1,.48,1v4.31a2.38,2.38,0,0,1-1.11,1.91l-3.73,2.15A1.23,1.23,0,0,1,189.52,329.56Zm.62-6.51a1.51,1.51,0,0,0-.65,1.13v4.31a.31.31,0,0,0,0,.18,1.37,1.37,0,0,0,.16-.07l3.73-2.15a1.49,1.49,0,0,0,.66-1.13V321a.28.28,0,0,0,0-.18.77.77,0,0,0-.17.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.15,319.49l14.7-8.49c.48-.28.88-.05.88.51v1.14a2,2,0,0,1-.88,1.52l-14.7,8.49c-.49.28-.88,0-.88-.51V321A1.93,1.93,0,0,1,198.15,319.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,340.51v1.69c0,.91.64,1.28,1.43.82l86-49.61a3.16,3.16,0,0,0,1.43-2.48v-1.69c0-.92-.64-1.29-1.43-.83l-86,49.62A3.16,3.16,0,0,0,125.33,340.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,350.69v1.69c0,.91.64,1.28,1.43.82l86-49.61a3.18,3.18,0,0,0,1.43-2.48v-1.69c0-.92-.64-1.29-1.43-.83l-86,49.62A3.16,3.16,0,0,0,125.33,350.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,351.56c2.25-2.23,2.81-3.18,2.81-4s-.33-1.27-1.34-.68a3.46,3.46,0,0,0-1.67,2.39l-2.46.55a9.2,9.2,0,0,1,4.21-6.29c2.46-1.42,3.89-.36,3.89,2.05a9.13,9.13,0,0,1-2.8,6.05v1.95l-2.64,1.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.88,358a2.77,2.77,0,0,1,1.34-2.4c.88-.5,1.33-.06,1.33.86a2.76,2.76,0,0,1-1.33,2.4C116.33,359.42,115.88,359,115.88,358Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.11,324.3l1.09.83-1,1.9a.66.66,0,0,0,0,.8c.18.14.46,0,.62-.3l1-1.9,1.1.84c.16.12.39,0,.53-.26a.57.57,0,0,0,0-.69l-1.1-.83,1-1.9a.69.69,0,0,0-.05-.8c-.18-.14-.46,0-.62.3l-1,1.9-1.1-.84c-.16-.11-.4,0-.53.26A.57.57,0,0,0,190.11,324.3Z",
    style: {
      fill: "#ADB793"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sad-face--inject-141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--sad-face--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.53,162.46l-7.35-4.24h0l-.07-.05v0c-3.66-2.07-8.67-1.76-14.22,1.45-5.2,3-9.94,8-13.51,13.77-4.13,6.66-6.72,14.36-6.72,21.27,0,6.45,2.25,11,5.9,13.09h0l7.47,4.27c3.68,2.35,8.89,2.14,14.66-1.19,11.18-6.46,20.24-22.15,20.24-35.05C293.92,169.09,291.46,164.46,287.53,162.46Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.87,212l-7.32-4.19h0c-3.65-2.12-5.9-6.65-5.9-13.09,0-6.91,2.59-14.61,6.72-21.27l7.81,4.51c-4.13,6.65-6.72,14.35-6.72,21.25C253.44,205.33,255.5,209.74,258.87,212Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.38,162.38c-3.6-1.75-8.41-1.31-13.7,1.74s-9.94,8-13.52,13.8l-7.81-4.51c3.57-5.79,8.32-10.78,13.51-13.77,5.55-3.21,10.56-3.51,14.22-1.45v0l.07.05h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.21,181.46a5.06,5.06,0,0,1-1.92,4.06c-1.06.61-1.92-.21-1.92-1.84a5.06,5.06,0,0,1,1.92-4.06C268.35,179,269.21,179.83,269.21,181.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.14,175.15a5.06,5.06,0,0,1-1.92,4.06c-1.06.61-1.92-.21-1.92-1.84a5.06,5.06,0,0,1,1.92-4.06C279.28,172.7,280.14,173.52,280.14,175.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.68,205.84a.91.91,0,0,1-.23,0,1.09,1.09,0,0,1-.85-1.3c1.74-8.27,6.17-15.51,11.28-18.46a8,8,0,0,1,7.14-.86c2.41,1,4.27,3.41,5.23,6.83a1.11,1.11,0,0,1-2.13.59c-.76-2.74-2.16-4.65-3.93-5.38A5.92,5.92,0,0,0,274,188c-4.52,2.61-8.63,9.44-10.22,17A1.11,1.11,0,0,1,262.68,205.84Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--happy-face--inject-141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--happy-face--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.53,98.48l-7.35-4.24h0l-.07,0v0c-3.66-2.07-8.67-1.76-14.22,1.45-5.2,3-9.94,8-13.51,13.77-4.13,6.66-6.72,14.36-6.72,21.27,0,6.45,2.25,11,5.9,13.09h0l7.47,4.27c3.68,2.35,8.89,2.14,14.66-1.19,11.18-6.46,20.24-22.15,20.24-35C293.92,105.11,291.46,100.48,287.53,98.48Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.87,148l-7.32-4.19h0c-3.65-2.12-5.9-6.65-5.9-13.09,0-6.91,2.59-14.61,6.72-21.27l7.81,4.51c-4.13,6.65-6.72,14.35-6.72,21.25C253.44,141.35,255.5,145.76,258.87,148Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.38,98.4c-3.6-1.75-8.41-1.31-13.7,1.74s-9.94,8-13.52,13.8l-7.81-4.51c3.57-5.79,8.32-10.78,13.51-13.77,5.55-3.21,10.56-3.51,14.22-1.45v0l.07,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.09,138.69a7.27,7.27,0,0,1-2.77-.54c-2.61-1.07-4.61-3.68-5.64-7.37a1.19,1.19,0,0,1,2.29-.64c.83,3,2.34,5,4.25,5.81a6.37,6.37,0,0,0,5.62-.79c4.87-2.81,9.31-10.19,11-18.35a1.2,1.2,0,0,1,1.41-.92,1.19,1.19,0,0,1,.92,1.41c-1.88,8.92-6.66,16.74-12.17,19.93A10,10,0,0,1,269.09,138.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.87,118.89a5.49,5.49,0,0,1-2.07,4.39c-1.15.66-2.07-.23-2.07-2a5.44,5.44,0,0,1,2.07-4.38C267.94,116.24,268.87,117.13,268.87,118.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.67,112.08a5.47,5.47,0,0,1-2.07,4.38c-1.14.66-2.07-.23-2.07-2a5.47,5.47,0,0,1,2.07-4.38C279.74,109.42,280.67,110.32,280.67,112.08Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.57,278.56l-53,30.6a3.79,3.79,0,0,1-3.44,0l-2.81-1.63a3.8,3.8,0,0,1-1.72-3v-61.2a3.8,3.8,0,0,1,1.72-3l53-30.6a3.77,3.77,0,0,1,3.43,0l2.81,1.64a3.78,3.78,0,0,1,1.72,3v61.21A3.8,3.8,0,0,1,302.57,278.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.28,309.29a3.84,3.84,0,0,1-3.15-.13l-2.81-1.64a3.77,3.77,0,0,1-1.71-3v-61.2a3.43,3.43,0,0,1,.5-1.7l6.24,3.63a3.5,3.5,0,0,0-.5,1.69v61.2C247.85,309.15,248.46,309.61,249.28,309.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.57,278.56l-53,30.6c-.95.55-1.72.11-1.72-1V247a3.8,3.8,0,0,1,1.72-3l53-30.6c.95-.55,1.72-.1,1.72,1v61.21A3.8,3.8,0,0,1,302.57,278.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.62,263.31l-14.4,20.4c6.36,6.43,18.6,1.6,27.34-10.79,5.25-7.43,8.07-15.45,8.07-22.94L278.2,260A13.59,13.59,0,0,0,274.62,263.31Z",
    style: {
      fill: "#ADB793",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.62,263.31l-14.4,20.4c6.36,6.43,18.6,1.6,27.34-10.79,5.25-7.43,8.07-15.45,8.07-22.94L278.2,260A13.59,13.59,0,0,0,274.62,263.31Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.49,283.19l14.4-20.4h0a14.27,14.27,0,0,1,3.86-3.53l17.43-10.06a.9.9,0,0,1,1.35.78c0,7.72-2.85,15.84-8.23,23.46-5.79,8.2-13.23,13.42-19.9,14a10.73,10.73,0,0,1-8.82-3.07.9.9,0,0,1-.14-1.08A.18.18,0,0,1,259.49,283.19Zm35.2-31.63-16,9.26a12.47,12.47,0,0,0-3.3,3l-13.95,19.75a9.11,9.11,0,0,0,6.84,2c6.06-.5,13.18-5.56,18.57-13.21.92-1.29,1.75-2.6,2.51-3.91A38.09,38.09,0,0,0,294.69,251.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.27,258.93,270,243.28c-10.28,9.79-15.91,25.79-12.57,35.73a11.53,11.53,0,0,0,2.78,4.7l14.4-20.4A5.49,5.49,0,0,0,275.27,258.93Z",
    style: {
      fill: "#ADB793",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.39,242.63a.89.89,0,0,1,.83-.23.93.93,0,0,1,.64.59l5.26,15.65a6.45,6.45,0,0,1-.76,5.19L261,284.23a.93.93,0,0,1-.66.37.88.88,0,0,1-.72-.26,12.45,12.45,0,0,1-3-5c-2.43-7.23-.27-17.57,4.91-26.54A45,45,0,0,1,269.39,242.63Zm4.5,20.16a4.59,4.59,0,0,0,.52-3.58h0l-4.8-14.28c-9.38,9.62-14.44,24.5-11.32,33.8a11.11,11.11,0,0,0,1.85,3.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.49,259.25l14.4-20.4c-5.08-5.14-13.66-3.41-21.88,4.43l5.26,15.65C275.7,260.23,276.7,260.37,277.49,259.25Z",
    style: {
      fill: "#ADB793",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.49,259.25l14.4-20.4c-5.08-5.14-13.66-3.41-21.88,4.43l5.26,15.65C275.7,260.23,276.7,260.37,277.49,259.25Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.39,242.63c8.6-8.2,17.69-9.93,23.14-4.41a.9.9,0,0,1,.1,1.15l-14.41,20.4a2,2,0,0,1-3.81-.56l-5.26-15.65a.89.89,0,0,1,.08-.73A.62.62,0,0,1,269.39,242.63ZM290.7,239c-4.67-4-12.25-2.29-19.66,4.56l5.08,15.1a1.71,1.71,0,0,0,.24.47,1,1,0,0,0,.39-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.2,260,295.63,250c0-5-1.2-8.55-3.74-11.13l-14.4,20.4C276.7,260.37,277,260.72,278.2,260Z",
    style: {
      fill: "#ADB793",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.2,260,295.63,250c0-5-1.2-8.55-3.74-11.13l-14.4,20.4C276.7,260.37,277,260.72,278.2,260Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.75,258.73l14.41-20.4a.89.89,0,0,1,.66-.37.87.87,0,0,1,.71.26c2.73,2.76,4,6.5,4,11.76a.9.9,0,0,1-.45.78l-17.42,10.06c-.38.22-1.52.88-2.22.11a1.48,1.48,0,0,1,0-1.79ZM292,240.3l-12.81,18.15,15.56-9C294.65,245.48,293.77,242.53,292,240.3Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubbles--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.75,186.5a6.55,6.55,0,0,0-5.91.11L316.7,239.23a6.73,6.73,0,0,0-3,5.28v26a5.72,5.72,0,0,0,8.76,5.06l91.14-52.62a6.73,6.73,0,0,0,3-5.28v-26A6.54,6.54,0,0,0,413.75,186.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.57,191.12c-.25-1.54-1.5-2.08-3-1.2l-38,21.93-53.14,30.68a6.22,6.22,0,0,0-2.16,2.27l-5.72-3.3a6.31,6.31,0,0,1,2.15-2.28l91.14-52.61a5.69,5.69,0,0,1,8.73,4.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.37,247.81v26c0,1.94,1.37,2.73,3.05,1.76l91.14-52.62a6.73,6.73,0,0,0,3-5.28v-26c0-1.94-1.36-2.73-3-1.76l-38,21.94-53.15,30.68A6.74,6.74,0,0,0,319.37,247.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.87,244l1.49,3.16a.35.35,0,0,0,.48.19l3.33-1.27c.53-.21.74.54.36,1.26l-2.41,4.52a1.55,1.55,0,0,0-.19.86l.57,4.1c.09.65-.46,1.5-.93,1.44l-3-.37a.75.75,0,0,0-.6.35l-3,3.81c-.47.6-1,.38-.93-.37l.57-4.75a.71.71,0,0,0-.19-.65l-2.41-1.74c-.38-.28-.17-1.27.36-1.67l3.33-2.57a1.48,1.48,0,0,0,.48-.75l1.49-4.88C334,243.9,334.63,243.51,334.87,244Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.72,234.36l1.49,3.16a.34.34,0,0,0,.48.19l3.33-1.27c.53-.21.74.54.36,1.26L355,242.22a1.57,1.57,0,0,0-.19.87l.57,4.09c.09.65-.46,1.5-.93,1.44l-3-.36a.71.71,0,0,0-.6.34l-3,3.81c-.47.6-1,.39-.93-.37l.57-4.75a.71.71,0,0,0-.19-.65l-2.41-1.74c-.38-.28-.17-1.26.36-1.67l3.33-2.57a1.48,1.48,0,0,0,.48-.75l1.49-4.88C350.8,234.25,351.48,233.86,351.72,234.36Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.57,224.72l1.49,3.16a.35.35,0,0,0,.48.19l3.33-1.28c.53-.2.74.54.36,1.26l-2.41,4.52a1.59,1.59,0,0,0-.19.87l.57,4.09c.09.65-.46,1.51-.93,1.45l-3-.37a.75.75,0,0,0-.6.35l-3,3.8c-.47.61-1,.39-.93-.36l.57-4.75a.73.73,0,0,0-.19-.66l-2.41-1.74c-.38-.27-.17-1.26.36-1.67l3.33-2.57a1.48,1.48,0,0,0,.48-.75l1.49-4.88C367.65,224.61,368.33,224.21,368.57,224.72Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.42,215.07l1.49,3.16a.35.35,0,0,0,.48.19l3.33-1.28c.53-.2.74.54.36,1.26l-2.41,4.52a1.59,1.59,0,0,0-.19.87l.57,4.09c.09.65-.46,1.51-.93,1.45l-3-.37a.75.75,0,0,0-.6.35l-3,3.8c-.47.61-1,.39-.93-.36l.57-4.75a.71.71,0,0,0-.19-.65l-2.41-1.74c-.38-.28-.17-1.27.36-1.68l3.33-2.56a1.57,1.57,0,0,0,.48-.75l1.49-4.88C384.5,215,385.18,214.57,385.42,215.07Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.27,205.42l1.49,3.16a.35.35,0,0,0,.48.19l3.33-1.27c.53-.21.74.54.36,1.26l-2.41,4.52a1.55,1.55,0,0,0-.19.86l.57,4.1c.09.65-.46,1.5-.93,1.44l-3-.37a.75.75,0,0,0-.6.35l-3,3.81c-.47.6-1,.38-.93-.37l.57-4.75a.71.71,0,0,0-.19-.65L395.45,216c-.38-.28-.17-1.27.36-1.67l3.33-2.57a1.48,1.48,0,0,0,.48-.75l1.49-4.88C401.35,205.31,402,204.92,402.27,205.42Z",
    style: {
      fill: "#ADB793"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.36,227.37l-5-2.88a.54.54,0,0,1-.24-.21l-.92-1.6,3-1.71-.09.26Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.36,227.37l-5-2.88a.54.54,0,0,1-.24-.21l-.92-1.6,3-1.71-.09.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.73,221.21l3.46,6a.51.51,0,0,0,.93-.09l3.65-10.53Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,137.6a5.3,5.3,0,0,0-2.41-4.17h0a5.38,5.38,0,0,0-4.82,0l-92.66,53.47a5.34,5.34,0,0,0-2.41,4.18v30.5a5.34,5.34,0,0,0,2.41,4.18h0a5.32,5.32,0,0,0,4.82,0l92.89-53.62c2.17-1.24,2.19-2.48,2.19-4Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.66,221.57a5.34,5.34,0,0,0,2.41,4.18h0a5.37,5.37,0,0,0,4.41.21c-1.13.43-2-.22-2-1.6V193.85a4.85,4.85,0,0,1,.71-2.37l-4.83-2.79a5,5,0,0,0-.7,2.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.89,136.92c-.28-1-1.22-1.35-2.33-.71l-92.67,53.47a4.77,4.77,0,0,0-1.7,1.8l-4.82-2.79a5,5,0,0,1,1.7-1.8l92.66-53.46a5.32,5.32,0,0,1,4.82,0h0A5.3,5.3,0,0,1,415.89,136.92Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,194.39l83.21-48.14c.81-.46,1.47-.25,1.47.48a2.91,2.91,0,0,1-1.47,2.16L325,197c-.8.47-1.46.26-1.46-.47A2.93,2.93,0,0,1,325,194.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,208l71.37-41.2c.81-.47,1.46-.26,1.46.47a2.93,2.93,0,0,1-1.46,2.17L325,210.63c-.8.47-1.46.25-1.46-.48A3,3,0,0,1,325,208Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,214.62l81.51-47.12c.8-.47,1.46-.25,1.46.48a3,3,0,0,1-1.46,2.16L325,217.25c-.8.47-1.46.26-1.46-.47A2.93,2.93,0,0,1,325,214.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,201l81.51-47.12c.8-.47,1.46-.25,1.46.48a2.94,2.94,0,0,1-1.46,2.16L325,203.68c-.8.46-1.46.25-1.46-.48A2.93,2.93,0,0,1,325,201Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.75,85.19a6.55,6.55,0,0,0-5.91.11L316.7,137.91a6.76,6.76,0,0,0-3,5.28v26a5.72,5.72,0,0,0,8.76,5.06l91.14-52.62a6.73,6.73,0,0,0,3-5.28v-26A6.54,6.54,0,0,0,413.75,85.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.57,89.81c-.25-1.54-1.5-2.08-3-1.21l-38,21.93-53.14,30.68a6.33,6.33,0,0,0-2.16,2.28l-5.72-3.3a6.23,6.23,0,0,1,2.15-2.28L407.84,85.3a5.69,5.69,0,0,1,8.73,4.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.37,146.5v26c0,1.94,1.37,2.73,3.05,1.76l91.14-52.62a6.73,6.73,0,0,0,3-5.28v-26c0-1.94-1.36-2.73-3-1.76l-38,21.93-53.15,30.69A6.74,6.74,0,0,0,319.37,146.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.87,142.7l1.49,3.16a.35.35,0,0,0,.48.19l3.33-1.28c.53-.2.74.55.36,1.26l-2.41,4.52a1.59,1.59,0,0,0-.19.87l.57,4.09c.09.65-.46,1.51-.93,1.45l-3-.37a.75.75,0,0,0-.6.35l-3,3.8c-.47.61-1,.39-.93-.36l.57-4.75a.71.71,0,0,0-.19-.65l-2.41-1.74c-.38-.28-.17-1.27.36-1.68l3.33-2.56a1.53,1.53,0,0,0,.48-.75l1.49-4.88C334,142.59,334.63,142.2,334.87,142.7Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.72,133.05l1.49,3.16a.35.35,0,0,0,.48.19l3.33-1.27c.53-.21.74.54.36,1.26L355,140.91a1.55,1.55,0,0,0-.19.86l.57,4.1c.09.65-.46,1.5-.93,1.44l-3-.37a.75.75,0,0,0-.6.35l-3,3.81c-.47.6-1,.39-.93-.37l.57-4.75a.71.71,0,0,0-.19-.65l-2.41-1.74c-.38-.28-.17-1.27.36-1.67l3.33-2.57a1.48,1.48,0,0,0,.48-.75l1.49-4.88C350.8,132.94,351.48,132.55,351.72,133.05Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.57,123.4l1.49,3.17a.35.35,0,0,0,.48.19l3.33-1.28c.53-.2.74.54.36,1.26l-2.41,4.52a1.57,1.57,0,0,0-.19.87l.57,4.09c.09.65-.46,1.5-.93,1.45l-3-.37a.71.71,0,0,0-.6.34l-3,3.81c-.47.6-1,.39-.93-.37l.57-4.75a.72.72,0,0,0-.19-.65l-2.41-1.74c-.38-.27-.17-1.26.36-1.67l3.33-2.57a1.48,1.48,0,0,0,.48-.75l1.49-4.88C367.65,123.3,368.33,122.9,368.57,123.4Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.42,113.76l1.49,3.16a.35.35,0,0,0,.48.19l3.33-1.28c.53-.2.74.54.36,1.26l-2.41,4.52a1.59,1.59,0,0,0-.19.87l.57,4.09c.09.65-.46,1.51-.93,1.45l-3-.37a.75.75,0,0,0-.6.35l-3,3.8c-.47.61-1,.39-.93-.36l.57-4.75A.73.73,0,0,0,381,126l-2.41-1.74c-.38-.27-.17-1.26.36-1.67l3.33-2.56a1.56,1.56,0,0,0,.48-.76l1.49-4.88C384.5,113.65,385.18,113.25,385.42,113.76Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.27,104.11l1.49,3.16a.35.35,0,0,0,.48.19l3.33-1.28c.53-.2.74.55.36,1.26L405.52,112a1.59,1.59,0,0,0-.19.87l.57,4.09c.09.65-.46,1.51-.93,1.45l-3-.37a.75.75,0,0,0-.6.35l-3,3.8c-.47.61-1,.39-.93-.36l.57-4.75a.71.71,0,0,0-.19-.65l-2.41-1.74c-.38-.28-.17-1.27.36-1.68l3.33-2.56a1.48,1.48,0,0,0,.48-.75l1.49-4.88C401.35,104,402,103.61,402.27,104.11Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.36,126.06l-5-2.88a.54.54,0,0,1-.24-.21l-.92-1.6,3-1.71-.09.26Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.36,126.06l-5-2.88a.54.54,0,0,1-.24-.21l-.92-1.6,3-1.71-.09.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.73,119.9l3.46,6a.51.51,0,0,0,.93-.09l3.65-10.53Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,36.29a5.34,5.34,0,0,0-2.41-4.18h0a5.32,5.32,0,0,0-4.82,0L316.07,85.58a5.34,5.34,0,0,0-2.41,4.18v30.5a5.34,5.34,0,0,0,2.41,4.18h0a5.32,5.32,0,0,0,4.82,0l92.89-53.63c2.17-1.23,2.19-2.47,2.19-4Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.66,120.26a5.34,5.34,0,0,0,2.41,4.18h0a5.33,5.33,0,0,0,4.41.2c-1.13.43-2-.21-2-1.59V92.54a4.92,4.92,0,0,1,.71-2.38l-4.83-2.78a5,5,0,0,0-.7,2.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.89,35.61c-.28-1-1.22-1.35-2.33-.71L320.89,88.37a4.77,4.77,0,0,0-1.7,1.8l-4.82-2.79a5,5,0,0,1,1.7-1.8l92.66-53.47a5.38,5.38,0,0,1,4.82,0h0A5.3,5.3,0,0,1,415.89,35.61Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,93.07l83.21-48.13c.81-.46,1.47-.25,1.47.48a2.91,2.91,0,0,1-1.47,2.16L325,95.71c-.8.47-1.46.26-1.46-.47A3,3,0,0,1,325,93.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,106.68l71.37-41.2c.81-.47,1.46-.26,1.46.47a2.9,2.9,0,0,1-1.46,2.16L325,109.32c-.8.46-1.46.25-1.46-.48A2.94,2.94,0,0,1,325,106.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,113.3l81.51-47.11c.8-.47,1.46-.25,1.46.47a3,3,0,0,1-1.46,2.17L325,115.94c-.8.47-1.46.26-1.46-.47A3,3,0,0,1,325,113.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,99.73l81.51-47.12c.8-.47,1.46-.25,1.46.48a3,3,0,0,1-1.46,2.16L325,102.36c-.8.47-1.46.26-1.46-.47A2.93,2.93,0,0,1,325,99.73Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.58,283.5l35.05-6.87a1.09,1.09,0,0,1,1,1.79l-23.77,26.92Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.65,278.42a1.09,1.09,0,0,0-1-1.79L387.79,278h0a6,6,0,0,1,2.82,5.59l0,.62Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.19,380.29l2.86-1.65,3.47-2,124.35-71.33a16,16,0,0,0-1-11.62c-2.49-5.56-7.31-10-11.31-10.21L235.31,354.8l-6.61,3.79C233.12,356.37,245.59,378,241.19,380.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.12,374.06l6.4-3.68c1.89-1,.81-5.65-1.4-10.45-2.93-6.38-8.68-12.56-11.19-11.23l-4.72,2.71-1.67,1c2.51-1.33,8.27,4.84,11.19,11.23,2.11,4.6,3.19,9.07,1.58,10.29h0A.43.43,0,0,1,252.12,374.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.71,373.13c4.39-2.33-8.18-24-12.58-21.66l-6.41,3.66c4.39-2.32,17,19.33,12.57,21.66Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.19,380.29l6.33-3.62c4.33-2.26-7.63-23.26-12.21-21.87a.77.77,0,0,0-.26.1l-6.35,3.69C233.12,356.37,245.59,378,241.19,380.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.81,277.24l-1.18-.61L369.2,290.54,237.7,366c-.25-.39-.45-.42-.61-.15,3.74,5.83,6.56,13.17,4.1,14.45l2.86-1.65,3.47-2,124.35-71.33h0l23.77-26.92A1,1,0,0,0,395.81,277.24Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.32,395.66l26.87-15.37c1.88-1,.84-5.58-1.33-10.35-2.91-6.39-8.64-12.63-11.16-11.35h0L201.72,374c-5.36,3.09-.43,14.71,5.54,19.91C209.48,395.9,212,396.77,214.32,395.66Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.92,387.33c-1.54-6.06-6.44-12-10.95-13.27a4.4,4.4,0,0,0-4,.55c-4,3.75.67,14.41,6.32,19.33,2.17,1.92,4.6,2.78,6.92,1.77C216.19,394.53,217,391.43,215.92,387.33Z",
    style: {
      opacity: 0.1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopperLogin);
export default __webpack_public_path__ + "static/media/shopper-login.685cbb4b9f39e2f73b402cae857636f4.svg";
export { ForwardRef as ReactComponent };